import { orderedValues } from '../orderedValues'

export const preventSubmission = (e) => {
    e.preventDefault()
}

export const setAllValuesToTouched = (formik) => {
    for (let value in formik.values) {
        formik.touched[value] = true
    }
}

export const scrollToFirstError = (formik, orderedValues) => {
    let errorsList = Object.keys(formik.errors)
    const firstError = orderedValues.filter((value) => { return formik.touched.hasOwnProperty(value) && formik.errors.hasOwnProperty(value) })[0]

    if (errorsList.length > 0) {
        try {
            window.scrollTo(
                {
                    left: 0,
                    top: document.getElementById(firstError).offsetTop - 100,
                    behavior: 'smooth'
                }
            )
        } catch (error) {
            console.log(error)
        }
    }
}

export const addSummaryBackLogic = (setShowSummary) => {
    window.history.pushState(null, '')
    window.onpopstate = (e) => {
        setShowSummary(false)
    }
}

export const removeSummaryBackLogic = (setShowSummary) => {
    window.removeEventListener('popstate', (e) => {
        setShowSummary(false)
    })
}

export const proceedToSummary = (values, setShowSummary) => {
    // dispatch(hideErrorModalAction())
    window.history.pushState({ summary: true }, '', window.location.href)
    window.sessionStorage.setItem('userInput', JSON.stringify(values))
    return setShowSummary(true)
}

export const checkFormForErrors = (e, noErrors, setErrorTofocus, setAllValuesToTouched, formik) => {
    preventSubmission(e)
    noErrors ? formik.handleSubmit(e) : setErrorTofocus(true);
    setAllValuesToTouched(formik);
    scrollToFirstError(formik, orderedValues);
}

export const assignPDFValuesML = (formik, dbFormSpec, formType, appContext, languageText) => {
    const userInput = formik.values;
    const sensitiveInfo = formik.values.sensitiveInfo
    const facilityList = formik.values.facilityList
    const infoToReleaseGroup = formik.values.infoToReleaseGroup
    const releaseMode = formik.values.releasemodePdf
    const proxyForm = formType === 'Representative';
    const patientForm = formType === 'Patient';
    const requestPurposeNumber = formik.values.requestPurposePdf
    const NYPOrg = dbFormSpec.facility.orgId.includes('7042') || dbFormSpec.facility.orgId.includes('7101') || dbFormSpec.facility.orgId.includes('7239')

    formik.setFieldValue('disclosurePurposeGroup', requestPurposeNumber === '1' ? NYPOrg ? `${languageText.purposeDisclosure.options.patrequest}` : `${languageText.purposeDisclosure.options.personal}` : requestPurposeNumber === '3' ? `${languageText.purposeDisclosure.options.continuation}` : requestPurposeNumber === '4' ? `${languageText.purposeDisclosure.options.insurance}` : requestPurposeNumber === '5' ? `${languageText.purposeDisclosure.options.immunization}` : requestPurposeNumber === '6' ? `${languageText.purposeDisclosure.options.legal}` : requestPurposeNumber === '7' ? `${languageText.purposeDisclosure.options.employer}` : formik.values.requestPurposePdf);

    patientForm && formik.setFieldValue('pdf_PAddress', `${formik.values.PAddress1} ${formik.values.PAddress2} ${formik.values.PCity} ${formik.values.PState} ${formik.values.PZip}`);
    proxyForm && formik.setFieldValue('RepName', `${formik.values.RepFName} ${formik.values.RepMName && formik.values.RepMName + ' '}${formik.values.RepLName}`);
    proxyForm && formik.setFieldValue('pdf_RepAddress', `${formik.values.RepAddress1} ${formik.values.RepAddress2} ${formik.values.RepCity} ${formik.values.RepState} ${formik.values.RepZip}`);
    proxyForm && formik.setFieldValue('pdf_rrelationship', formik.values.rrelationship);

    formik.setFieldValue('pdf_PName', `${formik.values.PFName} ${formik.values.PMName && formik.values.PMName + ' '}${formik.values.PLName}`);
    formik.setFieldValue('pdf_RAddress', `${formik.values.RAddress1} ${formik.values.RAddress2} ${formik.values.RCity} ${formik.values.RState} ${formik.values.RZip}`);
    formik.values.dosFrom1 && formik.values.dosTo1 && formik.setFieldValue('pdf_serviceDates', `${new Date(formik.values.dosFrom1).toLocaleDateString('en-US', { timeZone: 'UTC' })} - ${new Date(formik.values.dosTo1).toLocaleDateString('en-US', { timeZone: 'UTC' })}`);
    formik.setFieldValue('pdf_deliveryMethod', releaseMode === '2' ? `${languageText.deliveryMethod.options.option2}` : releaseMode === '5' ? `${languageText.deliveryMethod.options.option3}` : releaseMode === '7' ? `${languageText.deliveryMethod.options.option4}` : (releaseMode === '3' || releaseMode === '12') ? 'Fax' : (releaseMode === '8') ? `${languageText.deliveryMethod.options.option8}` : `${languageText.deliveryMethod.options.option7} ${dbFormSpec.facility.pickupLocation}`);
    formik.setFieldValue('pdf_sensitiveInfoList', sensitiveInfo.map((item) => {
        return item.toUpperCase() === 'PSY' ? `${languageText.SensitiveInfo.labels.psy}` : item.toUpperCase() === 'HIV' ? `${languageText.SensitiveInfo.labels.hiv}` : item.toUpperCase() === 'DRUG' ? `${languageText.SensitiveInfo.labels.drug}` : item.toUpperCase() === 'STD' ? `${languageText.SensitiveInfo.labels.STD}` : item.toUpperCase() === 'GENETICS' ? `${languageText.SensitiveInfo.labels.genetics}` : '' }).join(', '));


    (appContext.localValues && appContext.localValues.facilityList) ? formik.setFieldValue('pdf_facilitiesList', appContext.localValues.facilityList.join('   |   ')) : formik.setFieldValue('pdf_facilitiesList', facilityList.join(', '))


    formik.setFieldValue('pdf_releaseItemsList', infoToReleaseGroup.reduce((output, inputItem) => {

        for (let obj of dbFormSpec.release.items) {
            if (inputItem === obj.key) {
                if (output.length < 1) {
                    return output + obj.value
                }
                else {
                    return output + ' | ' + obj.value
                }
            }
        }
    }, '') + `${formik.values.txtotherrecords && ', ' + formik.values.txtotherrecords}`)


}